import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ContentMangtSummaryService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_SUMMARY_DATA, 'ChatGptUtilitySummaryStatus');
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    return this.getClient('aiadmin').post(`/chatutility/getsummary`, payload, { headers });
  }

  handleResponse(response) {
    const { data, status } = response;
    let responseMatch = false;
    if (data && data.data.length > 0) {
      const summaryArray = data.data;
      responseMatch = summaryArray.some((item) => item.type === 'bullet');
    }
    if (status === 200 && data.data.length > 0 && responseMatch) {
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data Not Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptSummaryUtility').resetStoreValues();
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('chatgptSummaryUtility').resetStoreValues();
  }
}
